import React, { useState, useEffect } from "react";
import "./Nav.css";
import { motion } from "framer-motion";
import { navItems } from "../../data/nav.data";
import { glitchItem, navContainer } from "../../animations";

const Nav = ({ rootLenisRef }) => {
  const [activeNav, setActiveNav] = useState("#header");

  const handleScroll = () => {
    const position = window.scrollY + 120;

    navItems.forEach(({ href }) => {
      const target = document.querySelector(href);
      if (!target) return;

      const top = target.offsetTop;
      const bottom = top + target.offsetHeight;

      if (position >= top && position < bottom) {
        setActiveNav(href);
      }
    });
  };

  const handleNavClick = (href) => {
    setActiveNav(href);

    const target = document.querySelector(href);
    if (!target) return;

    if (rootLenisRef?.current?.lenis) {
      rootLenisRef.current.lenis.scrollTo(target, {
        offset: 0,
        duration: 1,
        easing: (t) => t,
      });
    } else {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.nav variants={navContainer} initial="hidden" animate="visible">
      {navItems.map(({ href, icon, title }) => (
        <motion.a
          key={href}
          href={href}
          title={title}
          className={activeNav === href ? "active" : ""}
          onClick={(e) => {
            e.preventDefault(); // prevent default jump
            handleNavClick(href);
          }}
          variants={glitchItem}
          whileHover={{
            scale: 1.15,
            rotate: 10,
            transition: { duration: 0.1, ease: "easeInOut" },
          }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          {icon}
        </motion.a>
      ))}
    </motion.nav>
  );
};

export default Nav;
